import { IconButton } from 'component/Button'
import { getFilterCount, Option } from 'component/Select/Option'
import { Divider, Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { Count } from 'page/catalog/FilterAccordion/Count'
import { FilterList } from 'page/catalog/FilterAccordion/FilterList'
import { SearchPane } from 'page/catalog/FilterAccordion/SearchPane'
import { useDemo } from 'page/catalog/store/CatalogContext'
import { FilterStore } from 'page/catalog/store/FilterStore'
import css from './FilterAccordion.module.scss'

type Props = {
  filter: FilterStore
  options: (string | Option)[]
}

export const FilterAccordion = observer((props: Props) => {
  const { stand } = useDemo()
  const { filter } = props
  const { expand } = filter
  const options = props.options.map(it => typeof it == 'string' ? ({ value: it, label: it }) : it)
  const count = getFilterCount(filter, options)
  const mass = options.length > 8
  const clear = count > 0

  const onReset = useLatestCallback(() => {
    filter.value = []
  })

  const onExpand = useLatestCallback(() => {
    filter.expand = !filter.expand
  })

  return <Vertical>
    <Space className={css.header} gap={12} pad={[12, 8]} opposite wide onClick={onExpand}>
      <Space gap={8} wrap>
        <Typo size={11} medium upper>
          {filter.title}
        </Typo>
        <Count count={count} />
      </Space>
      <Space gap={8} center>
        {clear && <IconButton size={24} action={onReset}>
          <Icon size={16} name="close" />
        </IconButton>}
        <IconButton link size={24}>
          <Icon size={16} name={expand ? 'keyboard_arrow_up' : 'keyboard_arrow_down'} />
        </IconButton>
      </Space>
    </Space>
    {mass && expand && !stand && <SearchPane filter={filter} />}
    {expand && <FilterList filter={filter} options={options} />}
    <Divider tertiary />
  </Vertical>
})
